import styled, { css } from "styled-components";
import { SIDEBAR } from "../../constants";
import { zIndex } from "../../theme";
export const StyledWrapper = styled.div`
  opacity: 1;
  position: fixed;
  padding: 0 12px;
  inset: 0;
  z-index: ${zIndex.overlayMenu};
  background: var(--sinch-sys-color-container-main-default);
  display: flex;
  flex-direction: column;
`;

export const TabNavigation = styled.div`
  display: flex;
  min-height: ${SIDEBAR.mobileTab}px;
  margin: 8px 0 0 -8px;
  padding-bottom: 2px;
  position: relative;

  ::after {
    background: var(--sinch-comp-tab-color-default-border-initial);
    border-radius: 2px;
    bottom: 0;
    content: "";
    height: 2px;
    left: 8px;
    position: absolute;
    right: 0;
  }
`;

const selectedColor = "#3375d1";
export const Tab = styled.div<{ selected?: boolean }>`
  font-family: var(--sinch-ref-typography-font-family-main);
  font-weight: 500;
  font-size: 16px;
  -webkit-box-align: center;
  align-items: center;
  background: none;
  border: none;
  border-radius: 4px;
  color: #777;
  cursor: pointer;
  display: flex;
  flex: 1;
  justify-content: center;
  line-height: 32px;
  outline: none;
  padding: 0 8px;
  z-index: 2;
  ${({ selected }) =>
    selected &&
    css`
      color: ${selectedColor};
      cursor: default;
    `}
`;

export const Pointer = styled.div<{ left: number }>`
  background: ${selectedColor};
  border-radius: 2px;
  bottom: 0;
  height: 2px;
  position: absolute;
  transition: left 0.5s cubic-bezier(0.12, 0.9, 0.3, 0.9) 0s,
    width 0.5s cubic-bezier(0.12, 0.9, 0.3, 0.9) 0s;
  z-index: 1;
  left: ${({ left }) => left}px;
  width: 50%;
`;

export const MessagingMenuWrapper = styled.div`
  display: flex;
  transition: opacity 0.5s cubic-bezier(0.12, 0.9, 0.3, 0.9) 0s,
    width 0.5s cubic-bezier(0.12, 0.9, 0.3, 0.9) 0s;
  flex-direction: column;
  padding: 8px 0;
  gap: 8px;
  height: calc(100vh - ${SIDEBAR.mobileHeight}px - ${SIDEBAR.mobileTab}px);
  overflow-y: scroll;
`;

export const MessagingMenuSettingsWrapper = styled(MessagingMenuWrapper)`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const StyledSeparatorLine = styled.span`
  padding: 8px 0 0 0;
  border-bottom: 1px solid var(--sinch-comp-tab-color-default-border-initial);
`;

export const SettingsItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: scroll;
`;
